import React from 'react';

const SectionHeader = ({ number, label, title, kicker, className = '' }) => {
  return (
    <header className={`mb-12 md:mb-16 ${className}`}>
      <p className="label">
        {number}. {label}
      </p>
      <h2 className="mt-4 font-heading text-4xl font-bold tracking-tight text-white md:text-5xl">
        {title}
      </h2>
      {kicker && (
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-btc-muted md:text-lg">
          {kicker}
        </p>
      )}
    </header>
  );
};

export default SectionHeader;
